<template>
  <MenuItemShell
    v-bind="{ ...$attrs, ...$props }"
    :class="[`type--${sectionType}`, { 'd-inline-block': isGoinOnTheSide }]"
    :[itemPadding]="true"
    :hide-attrs="isGoinOnTheSide || !entity.attributes?.length"
    :hide-desc="isGoinOnTheSide"
    :hide-prices="isGoinOnTheSide"
    :desc-props="{ class: 'archivo--font' }"
    v-on="$listeners"
  >
    <template #title="{ content, mods, emitItemUpdated, dirtyUpdate }">
      <MenuItemTitle
        ref="selectedOnMountTarget"
        class="ranga--font"
        :content="content"
        :mods="mods"
        @update="emitItemUpdated('title', $event)"
        @dirtyUpdate="dirtyUpdate"
      />
      <span
        v-if="isGoinOnTheSide && !entity.isLast"
        class="ranga--font menu-item--separator"
        >&middot;</span
      >
    </template>

    <template #prices="{ prices, priceMods, emitItemUpdated }">
      <!-- TODO: using local computed because MenuItemShell doesn't expose hidePrices as a slot prop.
           Fix: add :hidePrices="hidePrices" to the #prices slot in MenuItemShell and use it here instead. -->
      <MenuItemPrices v-if="!isGoinOnTheSide"
        :prices="prices"
        :mods="priceMods"
        class="ranga--font"
        @update="emitItemUpdated('prices', $event)"
        @dirtyUpdate="adjustDirtScore"
      />
    </template>
  </MenuItemShell>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import selectedOnMountMixin from '@mixins/selected-on-mount'
import MenuItemMixin from '@mixins/menu-item'
import MenuItemShell from '@components/Menu/MenuItemShell.vue'

export default {
  name: 'BlueOakMenuItem',
  components: { MenuItemShell },
  mixins: [MenuItemMixin, clickaway, selectedOnMountMixin('entity.isNew')],
  props: {},
  data() {
    return {}
  },
  computed: {
    itemPadding() {
      return this.isCondensed ? 'py-0' : 'py-1'
    }, // itemPadding
    isGoinOnTheSide() {
      return this.sectionType === 'sides'
    }, // isGoinOnTheSide
  }, // computed
}
</script>

<style lang="scss">
@use "sass:math";
@import '@design';

$hover-border-w: 2px;
.menu-item {
  position: relative;
  transition: background-color 0.2s ease, transform 0.2s ease;
  &.standard {
    .menu-item--top {
      > * {
        line-height: 1;
      }
    }
  }
  &.condensed {
    .menu-item--top {
      > * {
        line-height: 0.8;
      }
    }
    .item-price {
      font-weight: bold;
    }
  }

  .menu-item--title,
  .menu-item--prices {
    font-size: 1.2em;
    text-transform: uppercase;
    letter-spacing: 0.046em;
  }
  .menu-item--description {
    font-size: 1em;
    font-weight: 500;
    line-height: 1.3;
  }
  &.sortable-ghost {
    background-color: rgba($color-db-green, 0.2);
    opacity: 0.4;
  }
  &.showing-ui {
    &.hovering,
    &.selected {
      $gutter: 20px;

      padding-right: $gutter;
      padding-left: math.div($gutter, 2);
      margin-right: -$gutter;
      margin-left: math.div(-$gutter, 2);
    }
  }
  &.hovering.showing-ui {
    background-color: rgba($color-db-teal, 0.5);
  }
  &.selected {
    background-color: rgba($color-db-green, 0.1);
  }
  &.delete-hover {
    background: rgba(red, 0.075) !important;
  }
  &.type--sides {
    .menu-item--separator {
      margin-right: 0.23em;
      margin-left: 0.15em;
      font-size: 2.4em;
      font-weight: 900;
      line-height: 0.6em;
    }
  }
}

.menu-element--dots {
  margin-bottom: 3px;
  border-bottom: 2px dotted #000;
}

.drag-handle--wrap {
  position: absolute;
  top: 50%;
  right: 0;
  min-width: 20px;
  height: 100%;
  transform: translateY(-50%);
  .drag-handle {
    font-size: 18px;
    cursor: pointer;
  }
}
</style>
